import React from 'react';
import Checkbox from '../../components/Checkbox/Checkbox';
import TextInput from '../../components/TextInput/TextInput';
import type { FilterTreeField } from '../types';

interface ListViewFilterValuesProps {
  field: FilterTreeField;
  /* Whether the field is filtered by picking values or by typing a term */
  usesOptions: boolean;
  checkedValues: string[];
  textValue: string;
  onToggleValue: (option: string) => void;
  onChangeText: (value: string) => void;
}

/* What is filtered on for the selected field: its options to tick, or a term
   the value has to contain */
const ListViewFilterValues = ({
  field,
  usesOptions,
  checkedValues,
  textValue,
  onToggleValue,
  onChangeText
}: ListViewFilterValuesProps) => {
  if (usesOptions)
    return (
      /* Keyed so re-opening on another field/filter remounts the checkboxes
         (they are uncontrolled, defaultChecked only applies on mount) */
      <div key={field.keyword}>
        {field.options.map((option) => (
          <div key={option} tw="mt-2">
            <Checkbox
              label={option}
              defaultChecked={checkedValues.includes(option)}
              onChange={() => onToggleValue(option)}
            />
          </div>
        ))}
      </div>
    );
  return (
    <div tw="mt-2">
      <TextInput
        inputValue={textValue}
        placeholder={i18n('Contains…')}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChangeText(event.target.value)
        }
      />
    </div>
  );
};

export default ListViewFilterValues;
